<template> 
  <div>
    <form
      v-if="!success"
      @submit.prevent="sendForm(value)">
      <h4 class="mb-3">Esqueceu sua senha?</h4>
      <p>Insira o endereço de email vinculado à sua conta para recuperar sua senha.</p>
      <div :class="{'box-loading': loading}">
        <div class="form-group">
          <label>{{ $t('Email') }}</label>
          <input
            v-autofocus
            type="text"
            class="form-control"
            v-model="value.email">
          <ValidateMessage :error="validateErrors.email" />
        </div>
        <div class="mb-3">
          <button
            type="submit"
            class="btn btn-primary">{{ $t('Enviar instruções de recuperação.') }}</button>
        </div>
        <p><router-link to="/auth">{{ $t('Voltar para a tela de login.') }}</router-link></p>
      </div>
    </form>

    <div v-if="success">
      <h3 class="text-success">E-mail enviado com sucesso</h3>
      <p>Você receberá um e-mail com instruções para redefinir a sua senha.</p>
      <p><router-link to="/auth">Voltar para o login</router-link></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PasswordNew',
  components: {
  },
  data () {
    return {
      value: {
        email: ''
      },
      success: false,
      loading: false,
      validateErrors: {}
    }
  },
  metaInfo () {
    return {
      title: this.$t('Change password')
    }
  },
  created () {
  },
  methods: {
    sendForm (value) {
      this.loading = true

      this.$store
      .dispatch('authPasswordRedefinedNotification', value)
      .then((response) => {
        this.loading = false
        this.success = true
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Auth/PasswordNew.vue